/* ============================================================
   FilamentHub — Mobile PDP Sticky Dock
   - Mobile only (<= 749px)
   - Product pages only
   - Hides aggressively during Judge.me review flow
   ============================================================ */

(function () {
  function isMobile() {
    return true;
  }

  function isProductPage() {
    return (
      document.querySelector("product-info") &&
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function findProductForm() {
    return (
      document.querySelector("product-form form[action*='/cart/add']") ||
      document.querySelector("form[action*='/cart/add']")
    );
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null) return false;
    const cs = getComputedStyle(el);
    return (
      cs.visibility !== "hidden" &&
      cs.display !== "none" &&
      parseFloat(cs.opacity || "1") > 0
    );
  }

 function findRealATC(form) {
  // 1. Prefer the visible preorder app button anywhere on the page.
  // Essential Preorder often renders outside the normal Shopify product form.
  const preorderSelectors = [
    ".essential--container--active button[data-essential-preorder-element='button']",
    "button[data-essential-preorder-element='button']",
    ".essential-preorder-container button",
    "[class*='essential-preorder'] button"
  ];

  for (const selector of preorderSelectors) {
    const btns = Array.from(document.querySelectorAll(selector)).filter(isVisible);

    const picked = btns.find((b) =>
      /pre.?order/i.test((b.innerText || b.textContent || "").trim())
    );

    if (picked) return picked;
  }

  // 2. Then look for visible buttons anywhere that clearly say Preorder.
  const globalButtons = Array.from(
    document.querySelectorAll("button, input[type='submit']")
  ).filter(isVisible);

  const globalPreorder = globalButtons.find((b) =>
    /pre.?order/i.test(
      ((b.innerText || b.textContent || b.value || "") + "").trim()
    )
  );

  if (globalPreorder) return globalPreorder;

  // 3. Fallback to the normal Shopify product form button.
  const scope = form || document;

  const candidates = Array.from(
    scope.querySelectorAll(
      [
        "button[name='add']",
        "button.product-form__submit",
        "button[id^='ProductSubmitButton']",
        "button[type='submit']"
      ].join(",")
    )
  ).filter(isVisible);

  const picked =
    candidates.find((b) =>
      /add to cart|sold out|unavailable/i.test(
        (b.innerText || b.textContent || "").trim()
      )
    ) || candidates[0];

  return picked || null;
}

  function ensureDock() {
    let dock = document.getElementById("fh-mobile-pdp-cta");
    if (dock) return dock;

    dock = document.createElement("div");
    dock.id = "fh-mobile-pdp-cta";
dock.innerHTML = `
  <button type="button" class="fh-btn fh-btn-primary" data-fh-atc>Add to cart</button>
  <button type="button" class="fh-btn fh-btn-secondary" data-fh-ship>Shipping Discount</button>
`;
    document.body.appendChild(dock);
    return dock;
  }



  function openShippingDrawer() {
    const bubbles = document.querySelectorAll(".wbubble");
    for (const b of bubbles) {
      const label = (b.querySelector(".wbubble__label")?.textContent || "").toLowerCase();
      if (label.includes("shipping")) {
        const btn = b.querySelector("button.wbubble__fab, .wbubble__fab");
        if (btn) {
          btn.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          return;
        }
      }
    }
    console.warn("Shipping bubble not found");
  }

  function init() {
    if (!isProductPage()) return;

    const dock = ensureDock();
    const form = findProductForm();

    const btnATC = dock.querySelector("[data-fh-atc]");
    const btnShip = dock.querySelector("[data-fh-ship]");


    let forceHideDock = false;
    let judgeHideTimer = null;

    function setDockVisibility() {
      const showDock = isMobile() && !forceHideDock;
      dock.style.display = showDock ? "grid" : "none";
      document.body.classList.toggle("fh-pdp-cta-on", showDock);
    }

    function hideDockForJudgeMe() {
      forceHideDock = true;
      setDockVisibility();

      if (judgeHideTimer) clearTimeout(judgeHideTimer);

      // keep it hidden for a while, since Judge.me mobile often opens async
      judgeHideTimer = setTimeout(() => {
        forceHideDock = false;
        setDockVisibility();
      }, 15000);
    }

    function releaseDock() {
      if (judgeHideTimer) {
        clearTimeout(judgeHideTimer);
        judgeHideTimer = null;
      }
      forceHideDock = false;
      setDockVisibility();
    }

    function isJudgeMeElement(el) {
      if (!el || el.nodeType !== 1) return false;

      if (
        el.closest(
          [
            "[class*='jdgm']",
            "[id*='jdgm']",
            ".jdgm-widget",
            ".jdgm-modal",
            ".jdgm-rev-widg",
            ".jdgm-write-rev",
            ".jdgm-form",
            ".jdgm-popup"
          ].join(",")
        )
      ) {
        return true;
      }

      const txt = (el.textContent || "").trim().toLowerCase();
      return (
        txt.includes("write a review") ||
        txt.includes("leave a review") ||
        txt.includes("review content") ||
        txt.includes("review title")
      );
    }

    function judgeMeLooksOpen() {
      const selectors = [
        "[class*='jdgm-modal']",
        "[class*='jdgm-write-rev']",
        "[class*='jdgm-popup']",
        "[class*='jdgm-form']",
        "[class*='jdgm-rev-widg']",
        "[class*='jdgm-quest']",
        "[id*='jdgm']"
      ];

      for (const selector of selectors) {
        const els = document.querySelectorAll(selector);
        for (const el of els) {
          const cs = getComputedStyle(el);
          const rect = el.getBoundingClientRect();

          const shown =
            cs.display !== "none" &&
            cs.visibility !== "hidden" &&
            parseFloat(cs.opacity || "1") > 0 &&
            rect.width > 0 &&
            rect.height > 0;

          if (!shown) continue;

          const text = (el.textContent || "").toLowerCase();
          if (
            text.includes("review content") ||
            text.includes("review title") ||
            text.includes("write a review") ||
            text.includes("leave a review") ||
            text.includes("terms and conditions")
          ) {
            return true;
          }
        }
      }

      return false;
    }

    function syncJudgeMeState() {
      if (judgeMeLooksOpen()) {
        forceHideDock = true;
      } else if (!judgeMeLooksOpen()) {
        forceHideDock = false;
      }
      setDockVisibility();
    }

    setDockVisibility();
    window.addEventListener("resize", setDockVisibility);
    window.addEventListener("orientationchange", setDockVisibility);

    // Any click on Judge.me UI: hide immediately
    document.addEventListener(
      "click",
      function (e) {
        const target = e.target;
        if (isJudgeMeElement(target)) {
          hideDockForJudgeMe();
        }
      },
      true
    );

    // If user focuses a Judge.me field, hide immediately
    document.addEventListener(
      "focusin",
      function (e) {
        const target = e.target;
        if (isJudgeMeElement(target)) {
          hideDockForJudgeMe();
        }
      },
      true
    );

    // Watch DOM for modal/popup render
    const judgeObserver = new MutationObserver(function () {
      syncJudgeMeState();
    });

    judgeObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style", "open"]
    });

    // Extra safety polling for mobile async popup rendering
    setInterval(syncJudgeMeState, 500);

    let observedBtn = null;
    let btnObserver = null;

    function syncATCState() {
      const real = findRealATC(form);

      const disabled = !!(real && real.disabled);
      btnATC.disabled = disabled;
      btnATC.setAttribute("aria-disabled", disabled ? "true" : "false");

      let label =
        (real && (real.innerText || real.textContent || real.value || "").replace(/\s+/g, " ").trim()) ||
        "Add to cart";

      label = label.replace(/loading|adding/i, "").trim() || label;

      // Normalise the label so the sticky button does not copy weird app/helper text.
      if (/pre.?order/i.test(label)) {
        label = "Preorder";
      } else if (/sold out|unavailable|out of stock/i.test(label)) {
        label = "Sold out";
      } else if (/add to cart/i.test(label)) {
        label = "Add to cart";
      }

      btnATC.textContent = label;
      dock.classList.toggle("fh-is-preorder", label === "Preorder");
      dock.classList.toggle("fh-is-sold-out", label === "Sold out");

      if (real && real !== observedBtn) {
        observedBtn = real;
        if (btnObserver) btnObserver.disconnect();

        btnObserver = new MutationObserver(syncATCState);
        btnObserver.observe(real, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
        });
      }
    }

    btnATC.addEventListener("click", function () {
      const real = findRealATC(form);
      if (real && !real.disabled) real.click();
    });

    btnShip.addEventListener("click", openShippingDrawer);


    syncATCState();

    if (form) {
      const formObs = new MutationObserver(syncATCState);
      formObs.observe(form, { childList: true, subtree: true, attributes: true });
      form.addEventListener("change", function () {
        setTimeout(syncATCState, 50);
      });
    }

    document.addEventListener("variant:change", function () {
      setTimeout(syncATCState, 50);
      setTimeout(syncATCState, 250);
      setTimeout(syncATCState, 750);
    });

    document.addEventListener("product:variant-change", function () {
      setTimeout(syncATCState, 50);
      setTimeout(syncATCState, 250);
      setTimeout(syncATCState, 750);
    });

    setTimeout(syncATCState, 200);
    setTimeout(syncATCState, 800);
    setTimeout(syncATCState, 1500);

    // Optional: if user taps outside / closes popup, restore dock quickly
    document.addEventListener(
      "click",
      function () {
        setTimeout(syncJudgeMeState, 150);
      },
      true
    );
  }

  document.addEventListener("DOMContentLoaded", init);
})();